import PricingPage from '../../components/pricing/pricingPage'

const Pricing = ({authUser}) => {
  return (
    <>
    <PricingPage authUser={authUser} />
    </>
  )
}

export default Pricing